import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
import Security from "./mixins/Security";
export default {
  meta: {
    meta: {
      description: {
        name: 'description',
        content: 'Carehood'
      },
      keywords: {
        name: 'keywords',
        content: 'disabilities,community,disability,NDIS'
      },
      equiv: {
        'http-equiv': 'Content-Type',
        content: 'text/html; charset=UTF-8'
      }
    }
  },
  mixins: [Security],
  components: {},
  mounted: function mounted() {
    var _this = this;

    // channels
    this.$socket.$subscribe('hook', function (data) {
      if (data.emit) {
        // new version
        if (data.emit === 'newVersion') {
          if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
              var _iterator = _createForOfIteratorHelper(registrations),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var registration = _step.value;
                  registration.update();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            });
          }

          setTimeout(function () {
            _this.$q.notify({
              icon: 'warning',
              message: 'A new version of the system has been deployed.<br/>Click refresh below to ensure you have the most up to date version of the system.',
              html: true,
              color: 'primary',
              multiLine: true,
              timeout: 0,
              actions: [{
                label: 'Refresh Now',
                color: 'white',
                handler: function handler() {
                  window.location.reload(true);
                }
              }]
            });
          }, 5000);
        } else {
          _this.$root.$emit(data.emit, data);
        }
      }
    }); // user channel

    this.$socket.$subscribe("user", function (data) {
      if (data.user_id === _this.user.id) {
        _this.$root.$emit(data.emit, data);
      }
    });
  }
};